import { Component, OnDestroy, OnInit } from '@angular/core';
import { IdleTimeoutService } from './core/authorisation/services/idle-timeout.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Sa.Connect';
  subscriptions: Subscription = new Subscription();
  
  constructor(
    private _idleTImeoutService: IdleTimeoutService, // Initializes the idle timeout service's timers
    public router: Router
  ) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptions.add(this.router.events.subscribe(event => {
      // Only send event to Google Analytics if it's a NavigationEnd event
      // AND the URL does not include '/authorisation/:token' (to avoid logging auth redirects)
      // AND the URL does not include '/AuthenticationAPI/SAML/AssertionConsumerService' (to avoid logging SAML redirects)
      if (event instanceof NavigationEnd 
          && event.urlAfterRedirects.includes('/authorisation/') === false
          && event.urlAfterRedirects.includes('/AuthenticationAPI/SAML/AssertionConsumerService') === false
      ) {
        gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects,
          page_title: document.title
        });
      }
    }));
  }


}
